export const clearFlatObject = (obj: { [x: string]: any }) =>
  Object.entries(obj).reduce((acc, curr) => {
    const [key, val] = curr
    // Правильная проверка: фильтруем только null, undefined и пустую строку
    if (val !== null && val !== undefined && val !== '') {
      acc[key] = val
    }
    return acc
  }, {} as { [x: string]: any })

export const formatPhone = (num: string): string | null => {
  if (!num) return null
  if (num.length !== 11) return num
  return num.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, '+$1 ($2) $3-$4-$5')
}

/**
 * Создает URLSearchParams с очищенными от пустых значений параметрами
 */
export const createCleanSearchParams = (params: Record<string, any>): URLSearchParams => {
  const cleanedParams = clearFlatObject(params)
  const searchParams = new URLSearchParams()

  Object.entries(cleanedParams).forEach(([key, value]) => {
    // Дополнительная проверка для массивов и объектов
    if (Array.isArray(value)) {
      if (value.length > 0) {
        searchParams.set(key, value.join(','))
      }
    } else if (typeof value === 'object') {
      // Пропускаем объекты
    } else {
      const strValue = String(value)
      // Не добавляем пустые строки, "undefined", "null"
      if (strValue && strValue !== 'undefined' && strValue !== 'null') {
        searchParams.set(key, strValue)
      }
    }
  })

  return searchParams
}
